import React from 'react';
import EstruturaPagina from '../../EstruturaPagina';

export const Startemy = () => {
    return (
        <div>
            <EstruturaPagina
                BackgroundImage={'/assets/startback.webp'}
                LogoImage={'/assets/logo-projeto/start.webp'}
                TituloNome={'Startemy'}
                LinkSite={'https://startemy-project.vercel.app'}
                LinkGit={'https://github.com/Lisboaseyth/Startemy-project'}
                TextoDescricao={'Projeto de um e-commerce completo na área de cursos tech online.'}
                ImgTec1={'/assets/react_img.webp'}
                NomeTec1={'React'}
                ImgTec2={'/assets/logotype.png'}
                NomeTec2={'TypeScript'}
                screenshots={[
                    { src: "/assets/img-slider/startemy/startback.webp" },
                    { src: "/assets/img-slider/startemy/start2.webp" },
                    { src: "/assets/img-slider/startemy/start3.webp" },
                    { src: "/assets/img-slider/startemy/start4.webp" },
                    { src: "/assets/img-slider/startemy/start5.webp" },
                    { src: "/assets/img-slider/startemy/start6.webp" },
                    { src: "/assets/img-slider/startemy/start7.webp" },
                    { src: "/assets/img-slider/startemy/start8.webp" },
                ]}
                video={"https://youtu.be/W1zQ4k9aU1A"}
            />
        </div>
    )
}